import React, { useEffect } from 'react';
import StreamedList from '../../../../StreamedList';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../../User/Avatar';
import UserLink from '../../../../User/Link';
import AuthorWatchButton from '../../../../Button/AuthorWatchButton';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import s from './AwardsPopupContents.scss';
const AwardsPopupContents = ({ streamId, givers, isInitialized, isLoading, currentUser, initializeStream })=>{
    useEffect(()=>{
        if (!isInitialized) {
            initializeStream();
        }
    }, [
        isInitialized,
        initializeStream
    ]);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'badge_popup'
        }
    }, isInitialized && /*#__PURE__*/ React.createElement(StreamedList, {
        streamId: streamId,
        className: s['list']
    }, givers.map((giver, index)=>{
        var _giver_profile;
        const isNotCurrentUser = giver.userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
        return /*#__PURE__*/ React.createElement(Flex, {
            key: `${streamId}-${index}-${giver.userId}`,
            className: s['item'],
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            withTooltip: false,
            user: giver,
            className: s['avatar'],
            size: 32
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['userlink-wrapper']
        }, /*#__PURE__*/ React.createElement(UserLink, {
            withTooltip: false,
            user: giver,
            className: s['userlink']
        }), /*#__PURE__*/ React.createElement("span", {
            className: s['tagline']
        }, (_giver_profile = giver.profile) === null || _giver_profile === void 0 ? void 0 : _giver_profile.tagline)), isNotCurrentUser && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
            author: giver
        }));
    })), (!isInitialized || isLoading) && /*#__PURE__*/ React.createElement(LoadingIndicator, null));
};
AwardsPopupContents.displayName = 'AwardsPopupContents';
export default AwardsPopupContents;

//# sourceMappingURL=AwardsPopupContents.js.map